import './_full-width-video.scss';
import Vimeo from '@vimeo/player';
import { responsive, debounce } from '../../../utilities';

$(() => {
    const $videoCtrs = $('.fw-video');
    $videoCtrs.each((_, videoCtr) => {
        const desktopVideo = videoCtr.querySelector('.fw-video__video-desktop > iframe');

        function initVideo(video, hasControls) {
            let muted = true;
            let play = true;

            const videoPlayer = new Vimeo(video);
            if (hasControls) {
                const $soundBtn = $(videoCtr).find('.fw-video__controls__sound');
                const $pauseBtn = $(videoCtr).find('.fw-video__controls__pause');
                if (muted) $soundBtn.addClass('muted');
                $soundBtn.on('click', () => {
                    muted = !muted;
                    if (muted) {
                        videoPlayer.setVolume(0);
                        $soundBtn.addClass('muted');
                    } else {
                        videoPlayer.setVolume(1);
                        $soundBtn.removeClass('muted');
                    }
                });

                $pauseBtn.on('click', () => {
                    play = !play;
                    if (play) {
                        videoPlayer.play();
                        $pauseBtn.removeClass('paused');
                    } else {
                        videoPlayer.pause();
                        $pauseBtn.addClass('paused');
                    }
                });
            }
        }

        function resize() {
            responsive.breakAt({
                callback: () => {
                    initVideo(desktopVideo, true);
                },
                from: 'sm',
            });
        }
        resize();
        window.addEventListener('resize', debounce(resize, 300));
    });
});
